// extracted by mini-css-extract-plugin
export default {"virtual":"Virtual_virtual__coucj","left":"Virtual_left__6xWCX","wrapper":"Virtual_wrapper__vAAlF"};